import z from 'zod';

export const actionOpenPageSchema = z.object({
  type: z.literal('page'),
  pageId: z.uuid(),
});

z.globalRegistry.add(actionOpenPageSchema, { id: 'action-open-page' });

export type ActionOpenPageSchema = z.infer<typeof actionOpenPageSchema>;

export const actionSchema = z.discriminatedUnion('type', [
  actionOpenPageSchema,
]);

z.globalRegistry.add(actionSchema, { id: 'action' });

export type ActionSchema = z.infer<typeof actionSchema>;
